import { BASVURU_DENETIM_SONUC_KRITERI_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const basvuruDenetimSonucKriterList = (basvuruId) => {
    return getRequest({url:BASVURU_DENETIM_SONUC_KRITERI_LISTESI+"?basvuruId="+basvuruId});
}

export default basvuruDenetimSonucKriterList;